import React from 'react';
import PropTypes from 'prop-types';
import { useStyles } from './styles';

const defaultHref = 'https://support.ecal.com/article-category/other-calendars/';
const hrefs = {
  apple: 'https://support.ecal.com/article/how-to-subscribe-on-apple-calendar-mac-desktop/',
  outlook: 'https://support.ecal.com/article/how-to-subscribe-from-outlook-2010-2013-or-2016/',
};

export function GuideLink (props) {
    const {
        selectedCalendar = '',
        label = '',
        commonUIStyles = {},
    } = props;

    const classes = useStyles({
        commonUIStyles,
    });
    function getLink () {
        if (hrefs[selectedCalendar]) {
            return hrefs[selectedCalendar];
        }
        return defaultHref;
    }
    return (
        <a
            href={getLink()}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
        >
            { label }
        </a>
    );
}

GuideLink.propTypes = {
    selectedCalendar: PropTypes.string,
    label: PropTypes.string,
    commonUIStyles: PropTypes.any,
};

export default GuideLink;
